import { useCallback, useEffect, useState } from "preact/hooks";
import axios from "axios";

export default function useKeys(target) {
    const [keys, setKeys] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    const fetchKeys = useCallback(async (target) => {
        setIsLoading(true);
        try {
            const response = await axios.get(`/user/resources/access-keys?target=${target}`);

            if (Array.isArray(response.data) && response.data.length === 0) {
                const newKeyResponse = await axios.post("/user/resources/access-key", { target: target });
                setKeys((prev) => [...prev, newKeyResponse.data]);
            } else {
                setKeys(response.data);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }, [target]);

    useEffect(() => {
        fetchKeys(target);
    }, [fetchKeys]);

    return { keys, fetchKeys, isLoading };
}